(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["celebrity-diaries"] && !Shopify.designMode) return;
  try {
    
  (function () {
    'use strict';

    if (!window.customElements || window.customElements.get('celebrity-diaries')) return;

    var ROOT = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
    var REDUCED_MOTION = window.matchMedia('(prefers-reduced-motion: reduce)');

    var LABELS = {
      add: 'Add to cart',
      soldOut: 'Sold out',
      unavailable: 'Unavailable',
      added: 'Added to cart.',
      viewCart: 'View cart',
      details: 'View full details',
      loading: 'Loading…',
      error: 'Something went wrong. Please try again.',
      quantity: 'Quantity',
      close: 'Close',
      prevImage: 'Previous image',
      nextImage: 'Next image',
    };

    /* ---------- Small helpers ---------- */

    function h(tag, attrs) {
      var el = document.createElement(tag);
      Object.keys(attrs || {}).forEach(function (key) {
        var value = attrs[key];
        if (value === false || value === null || value === undefined) return;
        if (key === 'text') el.textContent = value;
        else if (key.indexOf('on') === 0) el.addEventListener(key.slice(2), value);
        else el.setAttribute(key, value === true ? '' : value);
      });
      for (var i = 2; i < arguments.length; i++) appendChild(el, arguments[i]);
      return el;
    }

    function appendChild(el, child) {
      if (Array.isArray(child)) child.forEach(function (c) { appendChild(el, c); });
      else if (child) el.append(child);
    }

    // Round previous / next button used on the quick view image.
    function navButton(direction, label, onClick) {
      var button = h('button', {
        type: 'button',
        class: 'cd-qv__nav cd-qv__nav--' + direction,
        'aria-label': label,
        onclick: onClick,
      });
      button.innerHTML =
        '<svg viewBox="0 0 24 24" width="18" height="18" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true" focusable="false"><path d="' +
        (direction === 'prev' ? 'm15 5-7 7 7 7' : 'm9 5 7 7-7 7') +
        '"/></svg>';
      return button;
    }

    // Strip tags / decode entities from the shop money format so it can be set as text.
    function plainText(str) {
      var t = document.createElement('textarea');
      t.innerHTML = String(str || '').replace(/<[^>]*>/g, '');
      return t.value;
    }

    function formatMoney(cents, format) {
      var placeholder = /\{\{\s*(\w+)\s*\}\}/;
      function fmt(precision, thousands, decimal) {
        var parts = (cents / 100).toFixed(precision).split('.');
        var whole = parts[0].replace(/(\d)(?=(\d{3})+(?!\d))/g, '$1' + thousands);
        return whole + (parts[1] ? decimal + parts[1] : '');
      }
      var match = format.match(placeholder);
      var value;
      switch (match ? match[1] : 'amount') {
        case 'amount_no_decimals': value = fmt(0, ',', '.'); break;
        case 'amount_with_comma_separator': value = fmt(2, '.', ','); break;
        case 'amount_no_decimals_with_comma_separator': value = fmt(0, '.', ','); break;
        case 'amount_with_apostrophe_separator': value = fmt(2, "'", '.'); break;
        case 'amount_no_decimals_with_space_separator': value = fmt(0, ' ', ','); break;
        case 'amount_with_space_separator': value = fmt(2, ' ', ','); break;
        default: value = fmt(2, ',', '.');
      }
      return match ? format.replace(placeholder, value) : value;
    }

    function sized(src, width) {
      if (!src) return '';
      return src + (src.indexOf('?') === -1 ? '?' : '&') + 'width=' + width;
    }

    /* ---------- Quick view (one shared dialog for the page) ---------- */

    var QuickView = {
      dialog: null,
      body: null,
      cache: new Map(),
      current: null,
      onClose: null,

      ensure: function () {
        if (this.dialog) return;
        var self = this;
        var close = h('button', { type: 'button', class: 'cd-qv__close', 'aria-label': LABELS.close });
        close.innerHTML =
          '<svg viewBox="0 0 24 24" width="18" height="18" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" aria-hidden="true" focusable="false"><path d="M6 6l12 12M18 6 6 18"/></svg>';
        this.body = h('div', { class: 'cd-qv__body' });
        this.dialog = h('dialog', { class: 'cd-qv', 'aria-label': 'Quick view' }, close, this.body);

        close.addEventListener('click', function () { self.dialog.close(); });
        // A click that lands on the dialog element itself is a click on the backdrop.
        this.dialog.addEventListener('click', function (e) {
          if (e.target === self.dialog) self.dialog.close();
        });
        this.dialog.addEventListener('close', function () {
          document.documentElement.classList.remove('cd-qv-open');
          self.current = null;
          if (self.onClose) self.onClose();
          self.onClose = null;
        });
        document.body.appendChild(this.dialog);
      },

      load: function (handle) {
        var self = this;
        if (!this.cache.has(handle)) {
          var request = fetch(ROOT + 'products/' + encodeURIComponent(handle) + '.js', {
            headers: { Accept: 'application/json' },
          })
            .then(function (r) {
              if (!r.ok) throw new Error(String(r.status));
              return r.json();
            })
            .catch(function (err) {
              self.cache.delete(handle);
              throw err;
            });
          this.cache.set(handle, request);
        }
        return this.cache.get(handle);
      },

      open: function (trigger, host, onClose) {
        var self = this;
        var handle = trigger.dataset.handle;
        var url = trigger.dataset.url;
        this.ensure();

        if (typeof this.dialog.showModal !== 'function') {
          window.location.href = url;
          return;
        }

        var fallbackFormat = '{' + '{amount}' + '}';
        var config = {
          format: plainText(host.dataset.moneyFormat) || fallbackFormat,
          cartAction: host.dataset.cartAction,
          showBuy: host.dataset.qvBuy === 'true',
        };

        this.onClose = onClose;
        this.current = handle;
        this.body.textContent = '';
        this.body.append(h('div', { class: 'cd-qv__loading', role: 'status', text: LABELS.loading }));
        if (!this.dialog.open) this.dialog.showModal();
        document.documentElement.classList.add('cd-qv-open');

        this.load(handle)
          .then(function (product) {
            if (self.current === handle && self.dialog.open) self.render(product, url, config);
          })
          .catch(function () {
            if (self.current !== handle) return;
            self.body.textContent = '';
            self.body.append(
              h('div', { class: 'cd-qv__loading' },
                h('p', { text: LABELS.error }),
                h('a', { class: 'cd-qv__details', href: url, text: LABELS.details })
              )
            );
          });
      },

      render: function (product, url, config) {
        var money = function (cents) { return formatMoney(cents, config.format); };
        var showBuy = config.showBuy;
        var images = product.images || [];
        var first = product.variants.find(function (v) { return v.available; }) || product.variants[0];
        var state = { options: first.options.slice(), variant: first };
        var hasOptions = !(
          product.options.length === 1 &&
          product.options[0].values.length === 1 &&
          product.options[0].values[0] === 'Default Title'
        );

        /* Gallery: main image, previous / next buttons, counter and thumbnails */
        var main = h('img', { class: 'cd-qv__main', alt: product.title });
        var count = h('span', { class: 'cd-qv__count', 'aria-hidden': 'true' });
        var thumbs = [];
        var index = 0;

        function setMain(src) {
          if (!src) return;
          var found = images.indexOf(src);
          if (found > -1) index = found;
          main.src = sized(src, 1000);
          count.textContent = index + 1 + ' / ' + images.length;
          thumbs.forEach(function (t) {
            t.setAttribute('aria-current', t.dataset.src === src ? 'true' : 'false');
          });
        }

        function showImage(i) {
          if (!images.length) return;
          setMain(images[(i + images.length) % images.length]);
        }

        if (images.length > 1) {
          thumbs = images.slice(0, 8).map(function (src, i) {
            return h('button', {
              type: 'button',
              class: 'cd-qv__thumb',
              'data-src': src,
              'aria-label': 'Image ' + (i + 1),
              onclick: function () { setMain(src); },
            }, h('img', { src: sized(src, 160), alt: '', loading: 'lazy' }));
          });
        }

        var stage = h('div', { class: 'cd-qv__stage' }, main);
        if (images.length > 1) {
          stage.append(
            navButton('prev', LABELS.prevImage, function () { showImage(index - 1); }),
            navButton('next', LABELS.nextImage, function () { showImage(index + 1); }),
            count
          );

          // Phones: swipe left / right on the image to change it.
          var startX = null;
          stage.addEventListener('touchstart', function (e) {
            startX = e.touches[0].clientX;
          }, { passive: true });
          stage.addEventListener('touchend', function (e) {
            if (startX === null) return;
            var distance = e.changedTouches[0].clientX - startX;
            startX = null;
            if (Math.abs(distance) > 40) showImage(index + (distance < 0 ? 1 : -1));
          }, { passive: true });
        }

        var gallery = images.length
          ? h('div', { class: 'cd-qv__gallery' + (thumbs.length ? '' : ' cd-qv__gallery--single') },
              stage,
              thumbs.length ? h('div', { class: 'cd-qv__thumbs' }, thumbs) : null
            )
          : null;
        setMain(images[0]);

        /* Info */
        var price = h('div', { class: 'cd-qv__price' });
        var status = h('div', { class: 'cd-qv__status', role: 'status', 'aria-live': 'polite' });
        var qty = h('input', { type: 'number', min: '1', value: '1', inputmode: 'numeric', 'aria-label': LABELS.quantity });
        var addBtn = h('button', { type: 'button', class: 'cd-qv__add', onclick: add });

        function stepQty(delta) {
          qty.value = Math.max(1, (parseInt(qty.value, 10) || 1) + delta);
        }

        // Variant options, quantity and add to cart are only built when buying is turned on.
        var optionFields = !hasOptions || !showBuy ? [] : product.options.map(function (option, i) {
          return h('fieldset', { class: 'cd-qv__option' },
            h('legend', { text: option.name }),
            h('div', { class: 'cd-qv__values' }, option.values.map(function (value, j) {
              var id = 'cd-qv-' + product.id + '-' + i + '-' + j;
              return [
                h('input', {
                  type: 'radio',
                  id: id,
                  name: 'cd-qv-option-' + i,
                  value: value,
                  'data-index': i,
                  checked: state.options[i] === value,
                  onchange: function () {
                    state.options[i] = value;
                    update(true);
                  },
                }),
                h('label', { for: id, text: value }),
              ];
            }))
          );
        });

        var buyRow = !showBuy ? null : h('div', { class: 'cd-qv__buy' },
          h('div', { class: 'cd-qv__qty' },
            h('button', { type: 'button', 'aria-label': 'Decrease quantity', text: '−', onclick: function () { stepQty(-1); } }),
            qty,
            h('button', { type: 'button', 'aria-label': 'Increase quantity', text: '+', onclick: function () { stepQty(1); } })
          ),
          addBtn
        );

        var info = h('div', { class: 'cd-qv__info' },
          h('h3', { class: 'cd-qv__title', text: product.title }),
          price,
          optionFields,
          buyRow,
          showBuy ? status : null,
          h('a', {
            class: showBuy ? 'cd-qv__details' : 'cd-qv__details cd-qv__details--button',
            href: url,
            text: LABELS.details,
          })
        );

        function update(userChange) {
          var variant = product.variants.find(function (v) {
            return v.options.every(function (o, k) { return o === state.options[k]; });
          }) || null;
          state.variant = variant;

          price.textContent = '';
          if (variant) {
            if (variant.compare_at_price > variant.price) price.append(h('s', { text: money(variant.compare_at_price) }));
            price.append(h('span', { text: money(variant.price) }));
            if (userChange && variant.featured_image && variant.featured_image.src) setMain(variant.featured_image.src);
          }

          addBtn.disabled = !variant || !variant.available;
          addBtn.textContent = !variant ? LABELS.unavailable : variant.available ? LABELS.add : LABELS.soldOut;
          status.textContent = '';

          // Strike through option values that have no available variant with the current selection.
          info.querySelectorAll('input[type="radio"]').forEach(function (input) {
            var index = Number(input.dataset.index);
            var ok = product.variants.some(function (v) {
              return v.available && v.options.every(function (o, k) {
                return k === index ? o === input.value : o === state.options[k];
              });
            });
            input.classList.toggle('is-unavailable', !ok);
          });
        }

        function add() {
          var variant = state.variant;
          if (!showBuy || !variant || !variant.available) return;
          addBtn.disabled = true;
          addBtn.classList.add('is-loading');
          status.textContent = '';

          fetch(ROOT + 'cart/add.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
            body: JSON.stringify({
              items: [{ id: variant.id, quantity: Math.max(1, parseInt(qty.value, 10) || 1) }],
            }),
          })
            .then(function (r) {
              return r.json().then(function (data) { return { ok: r.ok, data: data }; });
            })
            .then(function (res) {
              if (!res.ok) throw new Error(res.data.description || res.data.message || LABELS.error);
              if (config.cartAction === 'redirect') {
                window.location.href = ROOT + 'cart';
                return;
              }
              status.append(h('span', { text: LABELS.added + ' ' }), h('a', { href: ROOT + 'cart', text: LABELS.viewCart }));
              // Hooks for themes / custom code that refresh the cart drawer or cart count.
              document.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true }));
              document.dispatchEvent(new CustomEvent('celebrity-diaries:added', { bubbles: true, detail: res.data }));
            })
            .catch(function (err) {
              status.textContent = (err && err.message) || LABELS.error;
            })
            .then(function () {
              addBtn.classList.remove('is-loading');
              addBtn.disabled = !state.variant || !state.variant.available;
            });
        }

        update(false);
        this.body.textContent = '';
        this.body.append.apply(this.body, [gallery, info].filter(Boolean));
      },
    };

    /* ---------- Carousel ---------- */

    class CelebrityDiaries extends HTMLElement {
      connectedCallback() {
        this.track = this.querySelector('[data-cd-track]');
        if (!this.track) return;

        if (!this.ready) {
          this.ready = true;
          this.originals = Array.from(this.track.children);
          this.clones = [];
          this.looping = null;
          this.running = false;
          this.reasons = new Set();
          this.holds = {};
          this.step = 0;
          this.setWidth = 0;

          this.autoplay = this.dataset.autoplay === 'true' && !REDUCED_MOTION.matches;
          this.mode = this.dataset.mode === 'continuous' ? 'continuous' : 'slide';
          this.interval = (parseFloat(this.dataset.speed) || 3) * 1000;
          if (!this.autoplay) this.classList.remove('cd--continuous');

          this.bind();
        }

        this.onVisibility = () => (document.hidden ? this.pause('hidden') : this.resume('hidden'));
        document.addEventListener('visibilitychange', this.onVisibility);

        this.resizeObserver = new ResizeObserver(() => this.measure());
        this.resizeObserver.observe(this.track);

        this.viewObserver = new IntersectionObserver((entries) => {
          entries[entries.length - 1].isIntersecting ? this.resume('offscreen') : this.pause('offscreen');
        });
        this.viewObserver.observe(this);

        this.measure();
      }

      disconnectedCallback() {
        this.running = false;
        this.stop();
        clearTimeout(this.scrollTimer);
        Object.keys(this.holds || {}).forEach((key) => clearTimeout(this.holds[key]));
        if (this.resizeObserver) this.resizeObserver.disconnect();
        if (this.viewObserver) this.viewObserver.disconnect();
        if (this.onVisibility) document.removeEventListener('visibilitychange', this.onVisibility);
      }

      bind() {
        this.addEventListener('click', (e) => {
          const eye = e.target.closest('[data-cd-quick-view]');
          if (eye) {
            e.preventDefault();
            this.pause('modal');
            QuickView.open(eye, this, () => this.resume('modal'));
            return;
          }
          const arrow = e.target.closest('[data-cd-arrow]');
          if (arrow) {
            this.hold('nav', 900);
            this.go(arrow.dataset.cdArrow === 'prev' ? -1 : 1);
          }
        });

        // Only on devices with a real mouse, so a phone can never get stuck paused.
        if (this.dataset.pauseOnHover === 'true' && window.matchMedia('(hover: hover) and (pointer: fine)').matches) {
          this.addEventListener('pointerenter', (e) => e.pointerType === 'mouse' && this.pause('hover'));
          this.addEventListener('pointerleave', (e) => e.pointerType === 'mouse' && this.resume('hover'));
        }

        // Keyboard users: stop moving while something inside has keyboard focus.
        this.addEventListener('focusin', (e) => {
          if (e.target.matches && e.target.matches(':focus-visible')) this.pause('focus');
        });
        this.addEventListener('focusout', (e) => {
          if (!this.contains(e.relatedTarget)) this.resume('focus');
        });

        this.track.addEventListener('touchstart', () => {
          clearTimeout(this.holds.touch);
          this.pause('touch');
        }, { passive: true });
        const touchEnd = () => this.hold('touch', 2500);
        this.track.addEventListener('touchend', touchEnd, { passive: true });
        this.track.addEventListener('touchcancel', touchEnd, { passive: true });

        this.track.addEventListener('wheel', (e) => {
          if (Math.abs(e.deltaX) > Math.abs(e.deltaY)) this.hold('wheel', 1500);
        }, { passive: true });

        this.track.addEventListener('scroll', () => {
          clearTimeout(this.scrollTimer);
          this.scrollTimer = setTimeout(() => this.normalize(), 120);
        }, { passive: true });
      }

      /* Work out slide width, whether there is anything to scroll, and build the loop. */
      measure() {
        const items = this.originals;
        if (!items.length) return;
        const first = items[0].getBoundingClientRect();
        if (!first.width) return;
        const last = items[items.length - 1].getBoundingClientRect();

        this.step = items.length > 1 ? items[1].getBoundingClientRect().left - first.left : first.width;

        const loop = last.right - first.left > this.track.clientWidth + 2;
        if (loop && !this.clones.length) this.buildClones();
        if (loop !== this.looping) {
          this.looping = loop;
          this.clones.forEach((clone) => { clone.hidden = !loop; });
          this.classList.toggle('cd--static', !loop);
          if (!loop) this.track.scrollLeft = 0;
        }
        this.setWidth = loop
          ? this.clones[0].getBoundingClientRect().left - items[0].getBoundingClientRect().left
          : 0;

        const media = this.querySelector('.cd__media');
        if (media) this.style.setProperty('--cd-arrow-top', media.offsetHeight / 2 + 'px');

        if (this.running && this.mode === 'continuous') this.pos = this.track.scrollLeft;
        this.refresh();
      }

      /* A second copy of every slide makes the carousel loop without a visible jump. */
      buildClones() {
        const fragment = document.createDocumentFragment();
        this.clones = this.originals.map((item) => {
          const clone = item.cloneNode(true);
          clone.setAttribute('aria-hidden', 'true');
          clone.querySelectorAll('a, button').forEach((el) => el.setAttribute('tabindex', '-1'));
          fragment.appendChild(clone);
          return clone;
        });
        this.track.appendChild(fragment);
      }

      /* Once we have scrolled a full set, hop back by one set (looks identical). */
      normalize() {
        if (!this.looping || !this.setWidth) return;
        const x = this.track.scrollLeft;
        if (x >= this.setWidth - 1) {
          this.track.scrollLeft = Math.max(0, x - this.setWidth);
          this.pos = this.track.scrollLeft;
        }
      }

      go(direction) {
        if (!this.looping || !this.step) return;
        this.normalize();
        let x = this.track.scrollLeft;
        if (direction < 0 && x < this.step / 2) {
          x += this.setWidth;
          this.track.scrollLeft = x;
        }
        const index = Math.round(x / this.step);
        this.track.scrollTo({ left: (index + direction) * this.step, behavior: 'smooth' });
      }

      pause(reason) {
        this.reasons.add(reason);
        this.refresh();
      }

      resume(reason) {
        this.reasons.delete(reason);
        this.refresh();
      }

      hold(reason, ms) {
        clearTimeout(this.holds[reason]);
        this.pause(reason);
        this.holds[reason] = setTimeout(() => this.resume(reason), ms);
      }

      refresh() {
        const run = Boolean(this.autoplay && this.looping && this.step && this.reasons.size === 0);
        if (run === this.running) return;
        this.running = run;
        run ? this.start() : this.stop();
      }

      start() {
        if (this.mode !== 'continuous') {
          this.timer = setInterval(() => this.go(1), this.interval);
          return;
        }
        this.pos = this.track.scrollLeft;
        let previous = 0;
        const tick = (now) => {
          if (!this.running) return;
          if (previous) {
            const elapsed = Math.min(now - previous, 64);
            this.pos += (this.step / this.interval) * elapsed;
            if (this.pos >= this.setWidth) this.pos -= this.setWidth;
            this.track.scrollLeft = this.pos;
          }
          previous = now;
          this.frame = requestAnimationFrame(tick);
        };
        this.frame = requestAnimationFrame(tick);
      }

      stop() {
        clearInterval(this.timer);
        cancelAnimationFrame(this.frame);
      }
    }

    window.customElements.define('celebrity-diaries', CelebrityDiaries);
  })();

  } catch(e) { console.error(e); }
})();
})();
